export default __webpack_public_path__ + "static/hubIcon-19e008a13862fa39817dac55b1bdf58f.png";